module.exports = __webpack_public_path__ + "img/71.628b896b.png";